// San Diego State's undergraduate majors (#2840). Read on 2026-10-01 from
// SDSU's official 2026-2027 General Catalog (catalog.sdsu.edu, catoid=12),
// Curricula by Department, which lists every program under its department
// with the degree. The catalog does not list programs by college (its
// Colleges pages describe each college but name no departments), so the
// majors are grouped by the degree they lead to, as the catalog's own
// Summary of Curricula Offered does. Each bachelor's line is kept once per
// degree; the catalog's emphases, specializations, tracks and concentrations
// are folded into their major and named in its note, as are the versions in
// preparation for a single subject teaching credential. Left out: minors,
// certificates, graduate and blended (4+1) programs, and the Nursing B.S.
// lines marked "Second Bachelor's Degree". Quirk: Nursing's "Registered
// Nurse, B.S." line is an option for students already licensed; it is named
// in the Nursing note, not as its own major. The catalog's "Women's" uses a
// curly apostrophe; it is typed straight here. The KB's majors list was the
// starting point; the catalog wins.
const majors = {
    "slug": "san-diego-state-university",
    "read": "2026-10-01",
    "intro": "Every bachelor's degree major in SDSU's official 2026-2027 General Catalog, grouped by the degree it leads to, with each major's emphases named in its note. Minors, certificates and graduate programs are left out.",
    "groups": [
        {
            "name": "Bachelor of Arts",
            "source": {
                "label": "SDSU 2026-2027 General Catalog, Curricula by Department",
                "url": "https://catalog.sdsu.edu/content.php?catoid=12&navoid=1122"
            },
            "majors": [
                {
                    "name": "Africana Studies",
                    "degree": "B.A."
                },
                {
                    "name": "American Indian Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Anthropology",
                    "degree": "B.A."
                },
                {
                    "name": "Art",
                    "degree": "B.A.",
                    "note": "Options: Applied Design; Interior Architecture; Painting and Printmaking; Sculpture; Studio Arts."
                },
                {
                    "name": "Art History",
                    "degree": "B.A."
                },
                {
                    "name": "Asian American Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Asian Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Astronomy",
                    "degree": "B.A."
                },
                {
                    "name": "Biology",
                    "degree": "B.A."
                },
                {
                    "name": "Brazilian Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Chemistry",
                    "degree": "B.A.",
                    "note": "Also offered in preparation for a single subject teaching credential."
                },
                {
                    "name": "Chicana and Chicano Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Classics",
                    "degree": "B.A.",
                    "note": "Options: Classical Humanities; Classical Language; Classical Languages with Honors."
                },
                {
                    "name": "Communication",
                    "degree": "B.A."
                },
                {
                    "name": "Comparative International Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Dance",
                    "degree": "B.A."
                },
                {
                    "name": "Economics",
                    "degree": "B.A.",
                    "note": "Options: International Economics; Public Policy; Quantitative Analysis."
                },
                {
                    "name": "English and Comparative Literature",
                    "degree": "B.A.",
                    "note": "Also offered in preparation for a single subject teaching credential."
                },
                {
                    "name": "Geography",
                    "degree": "B.A.",
                    "note": "Options: Environment, Sustainability, and Policy; General Geography; Geographic Information Science and Technology; Human Geography and Global Studies."
                },
                {
                    "name": "Geological Sciences",
                    "degree": "B.A."
                },
                {
                    "name": "Gerontology",
                    "degree": "B.A."
                },
                {
                    "name": "History",
                    "degree": "B.A."
                },
                {
                    "name": "Humanities",
                    "degree": "B.A."
                },
                {
                    "name": "Integrated Design",
                    "degree": "B.A."
                },
                {
                    "name": "Interdisciplinary Studies in Three Departments",
                    "degree": "B.A."
                },
                {
                    "name": "International Business",
                    "degree": "B.A.",
                    "note": "Options: Arabic - Middle East and North Africa; Asian Languages - Singapore; Chinese - Asia; English - North America; European Languages - North Atlantic; French - North America; French - Western Europe; German - Western Europe; Italian - Western Europe; Japanese - Asia; Korean - Asia; Portuguese - Latin America; Portuguese - Western Europe; Russian - Central Europe; Spanish - Latin America; Spanish - Western Europe."
                },
                {
                    "name": "International Security and Conflict Resolution",
                    "degree": "B.A.",
                    "note": "Options: Conflict in the Global System; Environment in the Global System; Justice in the Global System."
                },
                {
                    "name": "Islamic and Arabic Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Japanese",
                    "degree": "B.A."
                },
                {
                    "name": "Journalism",
                    "degree": "B.A.",
                    "note": "Options: Advertising; Media Studies; Public Relations."
                },
                {
                    "name": "Language, Culture, and Society",
                    "degree": "B.A."
                },
                {
                    "name": "Latin American Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Lesbian, Gay, Bisexual, Transgender, Queer, and Plus (LGBTQ+) Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Liberal Studies",
                    "degree": "B.A.",
                    "note": "Options: Education-Generalist; Elementary Education."
                },
                {
                    "name": "Linguistics",
                    "degree": "B.A."
                },
                {
                    "name": "Mathematics",
                    "degree": "B.A.",
                    "note": "Also offered in preparation for a single subject teaching credential."
                },
                {
                    "name": "Modern Jewish Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Music",
                    "degree": "B.A."
                },
                {
                    "name": "Musical Theatre",
                    "degree": "B.A."
                },
                {
                    "name": "Philosophy",
                    "degree": "B.A."
                },
                {
                    "name": "Physics",
                    "degree": "B.A."
                },
                {
                    "name": "Political Science",
                    "degree": "B.A."
                },
                {
                    "name": "Psychology",
                    "degree": "B.A.",
                    "note": "Options: Industrial and Organizational Psychology; Neuroscience."
                },
                {
                    "name": "Public Administration",
                    "degree": "B.A.",
                    "note": "Option: City Planning."
                },
                {
                    "name": "Religious Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Rhetoric and Writing Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Social Science",
                    "degree": "B.A.",
                    "note": "Also offered in preparation for a single subject teaching credential."
                },
                {
                    "name": "Social Work",
                    "degree": "B.A.",
                    "note": "Option: Community Corrections Case Management."
                },
                {
                    "name": "Sociology",
                    "degree": "B.A."
                },
                {
                    "name": "Spanish",
                    "degree": "B.A.",
                    "note": "Also offered in preparation for a single subject teaching credential."
                },
                {
                    "name": "Speech, Language, and Hearing Sciences",
                    "degree": "B.A."
                },
                {
                    "name": "Sustainability",
                    "degree": "B.A."
                },
                {
                    "name": "Theatre Arts",
                    "degree": "B.A.",
                    "note": "Options: Design and Technology; Performance; Youth Theatre; General Theatre Arts."
                },
                {
                    "name": "Urban Studies",
                    "degree": "B.A.",
                    "note": "Options: Urban Cultures and Societies; Urban Planning, Design, and Management; Urban Political Economy and Public Policy; Urban Sustainability."
                },
                {
                    "name": "Women's and Gender Studies",
                    "degree": "B.A."
                }
            ]
        },
        {
            "name": "Bachelor of Science",
            "source": {
                "label": "SDSU 2026-2027 General Catalog, Curricula by Department",
                "url": "https://catalog.sdsu.edu/content.php?catoid=12&navoid=1122"
            },
            "majors": [
                {
                    "name": "Aerospace Engineering",
                    "degree": "B.S."
                },
                {
                    "name": "Artificial Intelligence and Human Responsibility",
                    "degree": "B.S."
                },
                {
                    "name": "Astronomy",
                    "degree": "B.S.",
                    "note": "Option: Data Science."
                },
                {
                    "name": "Biology",
                    "degree": "B.S.",
                    "note": "Options: Cellular and Molecular Biology; Ecology; Evolutionary Biology; Marine Biology; Zoology. Also offered in preparation for a single subject teaching credential."
                },
                {
                    "name": "Business Administration",
                    "degree": "B.S.",
                    "note": "Options: Accounting; General Business; Finance; Financial Services; Real Estate; Management; Entrepreneurship; Human Resource Management; Information Systems; Marketing."
                },
                {
                    "name": "Chemistry",
                    "degree": "B.S.",
                    "note": "Option: Biochemistry."
                },
                {
                    "name": "Child Development",
                    "degree": "B.S.",
                    "note": "Option: Early Childhood Special Education Integrated Teacher Education (ITEP)."
                },
                {
                    "name": "Civil Engineering",
                    "degree": "B.S."
                },
                {
                    "name": "Computer Engineering",
                    "degree": "B.S."
                },
                {
                    "name": "Computer Science",
                    "degree": "B.S."
                },
                {
                    "name": "Construction Engineering",
                    "degree": "B.S."
                },
                {
                    "name": "Construction Management",
                    "degree": "B.S."
                },
                {
                    "name": "Criminal Justice",
                    "degree": "B.S."
                },
                {
                    "name": "Electrical Engineering",
                    "degree": "B.S."
                },
                {
                    "name": "Environmental Engineering",
                    "degree": "B.S."
                },
                {
                    "name": "Environmental Sciences",
                    "degree": "B.S."
                },
                {
                    "name": "Foods and Nutrition",
                    "degree": "B.S."
                },
                {
                    "name": "Geography",
                    "degree": "B.S.",
                    "note": "Options: Geographic Information Science and Technology; Water, Climate, and Ecosystems."
                },
                {
                    "name": "Geological Sciences",
                    "degree": "B.S.",
                    "note": "Options: Environmental Geosciences; General Geology; Geophysics."
                },
                {
                    "name": "Health Communication",
                    "degree": "B.S."
                },
                {
                    "name": "Hospitality and Tourism Management",
                    "degree": "B.S.",
                    "note": "Options: Hotel Operations and Management; Meetings and Events Operations and Management; Restaurant Operations and Management; Tribal Gaming Operations and Management."
                },
                {
                    "name": "Kinesiology",
                    "degree": "B.S.",
                    "note": "Options: Exercise Science Generalist; Fitness Specialist; Prephysical Therapy."
                },
                {
                    "name": "Leadership Studies",
                    "degree": "B.S."
                },
                {
                    "name": "Mathematics",
                    "degree": "B.S.",
                    "note": "Options: Applied Mathematics; Computational Science; Mathematics Education; Science."
                },
                {
                    "name": "Mechanical Engineering",
                    "degree": "B.S.",
                    "note": "Option: Bioengineering."
                },
                {
                    "name": "Microbiology",
                    "degree": "B.S.",
                    "note": "Option: Clinical Laboratory Science."
                },
                {
                    "name": "Nursing",
                    "degree": "B.S.",
                    "note": "The catalog also lists a Registered Nurse option, for students who are already registered nurses."
                },
                {
                    "name": "Physics",
                    "degree": "B.S.",
                    "note": "Options: General Physics; Modern Optics."
                },
                {
                    "name": "Public Health",
                    "degree": "B.S.",
                    "note": "Option: Environmental Health."
                },
                {
                    "name": "Recreation Administration",
                    "degree": "B.S.",
                    "note": "Options: Outdoor Resource Management; Recreation Systems Management; Sustainable Tourism Management."
                },
                {
                    "name": "Statistics",
                    "degree": "B.S.",
                    "note": "Options: Actuarial Science; Data Science."
                },
                {
                    "name": "Television, Film and New Media",
                    "degree": "B.S.",
                    "note": "Options: Critical Studies; Production."
                }
            ]
        },
        {
            "name": "Bachelor of Fine Arts",
            "source": {
                "label": "SDSU 2026-2027 General Catalog, Curricula by Department",
                "url": "https://catalog.sdsu.edu/content.php?catoid=12&navoid=1122"
            },
            "majors": [
                {
                    "name": "Dance",
                    "degree": "B.F.A.",
                    "note": "Option: Dance Education."
                }
            ]
        },
        {
            "name": "Bachelor of Music",
            "source": {
                "label": "SDSU 2026-2027 General Catalog, Curricula by Department",
                "url": "https://catalog.sdsu.edu/content.php?catoid=12&navoid=1122"
            },
            "majors": [
                {
                    "name": "Music",
                    "degree": "B.M.",
                    "note": "Options: General; Global Composition; Jazz Studies; Music Education; Music Entrepreneurship and Business; Music Recording Technology and Audio Design; Performance."
                }
            ]
        }
    ]
};

export default majors;
